import Header from './components/Header';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center bg-white">
        <div className="text-center px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Hoş Geldiniz</h1>
          <p className="text-xl text-gray-600 mb-8">Ana sayfa içeriği buraya eklenecek</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
